/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { FaPaperclip } from 'react-icons/fa';
import { IoMdCloseCircle, IoIosOptions } from 'react-icons/io';
import ReactQuill from 'react-quill';

import {
  Button,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Form,
  Input,
  Label,
  UncontrolledDropdown,
  InputGroup,
  InputGroupText,
  Row,
  Col
} from 'reactstrap';
import Select from 'react-select';
import EmailSignatureService from '../../../../../Protocol/service/emailService';

import { useProtocolAttachments } from '../../../../../Protocol/updateForm/components/Attachments/useProtocolAttachments';
import {
  CheckboxSignatureWrapper,
  CommentsFormWrapper,
  OptionSendSignatureDescription,
  OptionSendSignatureWrapper,
  SpanSignature
} from './styled';
import DefaultModal from 'components/Modal/DefaultModal';
import OpportunityService from '../../../services/opportunityService';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';
import { buttonStyle } from 'components/Containers/ConfigurationContainer/components/utils';
import { custom_select } from 'assets/styles/multiple_select';
import { useRecordTypesByUser } from '../../../../../RecordType/hooks/useRecordTypesByUser';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import ReactLoader from 'components/Loader';

var modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    [{ font: [] }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' }
    ],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    ['link', 'image', 'code-block'],
    ['clean']
  ]
};

const SendEmailModal = ({
  opportunityEmail,
  opportunityId,
  isModalOpen,
  onModalToggle,
  setIsModalOpen
}) => {
  const [description, setDescription] = useState('');
  const [subject, setSubject] = useState('');
  const [files, setFiles] = useState([]);
  const [attachments, setAttachments] = useState([]);
  const [attachmentsToRemove, setAttachmentsToRemove] = useState([]);
  const [sendSignature, setSendSignature] = useState(false);
  const [hasSignature, setHasSignature] = useState(false);
  const [openProtocol, setOpenProtocol] = useState(false);
  const [selectedRecordType, setSelectedRecordType] = useState();
  const [protocolTitle, setProtocolTitle] = useState('');
  const [isSendingEmail, setIsSendingEmail] = useState(false);

  const systemConfiguration = useSelector((state) => state.systemConfiguration);
  const { recordTypes, getRecordTypesByUser } = useRecordTypesByUser(
    entitiesName.PROTOCOL
  );

  useEffect(() => {
    getRecordTypesByUser();
  }, [getRecordTypesByUser]);

  const handleSelectedRecordTypeChange = (data) => {
    if (!data) {
      setSelectedRecordType(null);
    }
    setSelectedRecordType(data);
  };

  const handleProtocolTitleChange = (data) => {
    if (!data) {
      setProtocolTitle('');
    }
    setProtocolTitle(data);
  };

  const {
    getFileURL,
    getFileExtensionFromName,
    getIconFromFileExtension,
    getFileNameFormatted
  } = useProtocolAttachments();

  const handleDescriptionChange = (event) => {
    setDescription(event);
  };

  const handleSubjectChange = (event) => {
    setSubject(event.target.value);
  };

  const handleAddNewFile = (event) => {
    const uploadedFiles = event?.target?.files;

    if (!uploadedFiles || !uploadedFiles.length) return;

    const fileAlreadyUploaded = [...uploadedFiles].some((uploadedFile) =>
      files.some((file) => file.name === uploadedFile.name)
    );

    if (fileAlreadyUploaded) {
      event.target.value = '';
      return;
    }

    setFiles([...files, ...uploadedFiles]);
    event.target.value = '';
  };

  const onSubmit = async (data) => {
    await OpportunityService.sendEmail(data)
      .then((response) => {
        toast.success(
          response.data.data.message ||
            'Email enviado e um protocolo foi criado.',
          { autoClose: 3000, closeOnClick: true }
        );
      })
      .catch((error) => {
        setIsSendingEmail(false);
        const msg = error?.response?.data?.message;
        toast.error(msg || 'Ocorreu um erro ao enviar email à oportunidade');
      })
      .finally(() => {
        setIsSendingEmail(false);
        setIsModalOpen(false);
      });
  };

  const handleDeleteAttachment = (attachmentId) => {
    return () => {
      setAttachmentsToRemove((prevState) => [...prevState, attachmentId]);
      setAttachments((prevState) =>
        prevState.filter((attachment) => attachment.id !== attachmentId)
      );
    };
  };

  function handleSubmit(callback) {
    const formData = new FormData();

    formData.append('description', description);
    formData.append('subject', subject);
    formData.append('sendSignatureEmail', sendSignature);
    formData.append('opportunityEmail', opportunityEmail);
    formData.append('opportunityId', opportunityId);
    formData.append('recordTypeId', selectedRecordType?.value);
    formData.append('protocolTitle', protocolTitle);

    for (const file of files) {
      formData.append('attachments', file, file.name);
    }

    for (const attachmentToRemove of attachmentsToRemove) {
      formData.append('attachmentsToRemove', attachmentToRemove);
    }

    return async (event) => {
      setIsSendingEmail(!isSendingEmail);
      event.preventDefault();

      await callback(formData);

      setDescription('');
      setSubject('');
      setSelectedRecordType(null);
      setFiles([]);
      setOpenProtocol(false);
    };
  }

  async function mustSendSignature(userLogin) {
    await EmailSignatureService.mustSendSignature(userLogin);
  }

  useEffect(() => {
    EmailSignatureService.getSignature(localStorage.getItem('login'))
      .then((response) => {
        if (response) {
          setHasSignature(true);
          setSendSignature(response.must_send);
        }
      })
      .then(() => {});
  }, []);

  const getSelectOptionsDTO = () => {
    if (!recordTypes) return [];
    return recordTypes.map((group) => ({
      label: group.name,
      value: group.id
    }));
  };

  return (
    <>
      <DefaultModal
        show={isModalOpen}
        onModalToggle={onModalToggle}
        title={'Enviar email para a Oportunidade'}
        showCloseButton={false}
        modalContainerClasses="modal-xl"
      >
        {!openProtocol ? (
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <h3>
              O envio de email abrirá um protocolo de atendimento. Deseja
              continuar?
            </h3>
            <div style={{ alignSelf: 'flex-end' }}>
              <Button
                style={buttonStyle(systemConfiguration.primary_color)}
                className="ml-auto"
                data-dismiss="modal"
                type="button"
                onClick={() => setOpenProtocol(true)}
              >
                Sim
              </Button>
              <Button
                style={buttonStyle(
                  systemConfiguration.cancelation_button_color
                )}
                className="ml-auto"
                data-dismiss="modal"
                type="button"
                onClick={() => setIsModalOpen(false)}
              >
                Não
              </Button>
            </div>
          </div>
        ) : (
          <Form
            className="needs-validation rounded p-2"
            onSubmit={handleSubmit(onSubmit)}
            autoComplete="off"
          >
            <Row className="mb-3">
              <Col sm="8">
                <label className="form-control-label">
                  Título do protocolo
                </label>
                <Input
                  onChange={(event) =>
                    handleProtocolTitleChange(event.target.value)
                  }
                  type="text"
                  placeholder="Título"
                />
              </Col>
              <Col md="4">
                <label className="form-control-label">Tipo de registro</label>
                <Select
                  styles={custom_select}
                  placeholder="Selecione..."
                  options={getSelectOptionsDTO() || []}
                  isSearchable={false}
                  isClearable={false}
                  name="recordType"
                  defaultValue=""
                  value={selectedRecordType}
                  onChange={handleSelectedRecordTypeChange}
                />
              </Col>
            </Row>
            <Row className="mb-3">
              <Col md="12">
                <label className="form-control-label">Email</label>
                <div
                  style={{
                    background: '#fff',
                    boxShadow: '0px 0px 3px 1px #00000050'
                  }}
                >
                  <div
                    className="rounded overflow-hidden"
                    style={{
                      marginBottom: '4px'
                    }}
                  >
                    <>
                      <InputGroup>
                        <InputGroupText
                          className="form-control-label"
                          style={{
                            width: '8%',
                            borderRight: 'none',
                            borderTop: 'none',
                            borderBottom: 'none',
                            borderRadius: '0px',
                            borderLeft: 'none'
                          }}
                        >
                          Para
                        </InputGroupText>
                        <Input
                          style={{
                            border: 'none',
                            boxShadow: 'none'
                          }}
                          type="text"
                          rows="5"
                          name="destiny"
                          value={opportunityEmail || ''}
                          disabled={!opportunityEmail}
                          placeholder=""
                          onChange={() => {}}
                          className="rounded-0  p-2"
                        />
                      </InputGroup>

                      <InputGroup>
                        <InputGroupText
                          className="form-control-label"
                          style={{
                            width: '8%',
                            borderRight: 'none',
                            borderRadius: '0px',
                            borderLeft: 'none',
                            boxShadow: 'none'
                          }}
                        >
                          Assunto
                        </InputGroupText>

                        <Input
                          style={{
                            boxShadow: 'none',
                            borderRight: 'none',
                            borderLeft: 'none'
                          }}
                          type="text"
                          rows="5"
                          name="assunto"
                          placeholder="Digite um assunto"
                          value={subject}
                          onChange={handleSubjectChange}
                          className="rounded-0  p-2"
                        />
                      </InputGroup>
                    </>
                    <CommentsFormWrapper>
                      <ReactQuill
                        modules={modules}
                        name="description"
                        theme="snow"
                        placeholder="Descrição"
                        defaultValue={description}
                        onChange={handleDescriptionChange}
                        value={description}
                        style={{
                          border: 'none',
                          boxShadow: 'none'
                        }}
                      />
                    </CommentsFormWrapper>

                    {files.length || attachments.length ? (
                      <div className=" bg-white p-2 d-flex flex-column align-items-start">
                        {attachments.map((attachment) => (
                          <div
                            key={attachment.id}
                            title={attachment.name}
                            className="attachment-name-container p-2 pr-5 br-2 position-relative"
                          >
                            <img
                              src={getIconFromFileExtension(
                                getFileExtensionFromName(attachment.name)
                              )}
                              width="24px"
                              height="24px"
                              alt={attachment.name}
                              className="d-inline-block mr-2"
                            />
                            <a
                              href={getFileURL(attachment.path)}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={true}
                              style={{
                                fontSize: '14px'
                              }}
                            >
                              {getFileNameFormatted(attachment.name)}
                            </a>
                            <IoMdCloseCircle
                              type="button"
                              onClick={handleDeleteAttachment(attachment.id)}
                              className="delete-icon"
                            />
                          </div>
                        ))}
                        {files.map((attachment) => (
                          <div
                            key={attachment.id}
                            title={attachment.name}
                            className="attachment-name-container p-2 pr-5 br-2 position-relative"
                          >
                            <img
                              src={getIconFromFileExtension(
                                getFileExtensionFromName(attachment.name)
                              )}
                              width="24px"
                              height="24px"
                              alt={attachment.name}
                              className="d-inline-block mr-2"
                            />
                            <a
                              href={getFileURL(attachment.path)}
                              target="_blank"
                              rel="noopener noreferrer"
                              download={true}
                              style={{
                                fontSize: '14px'
                              }}
                            >
                              {getFileNameFormatted(attachment.name)}
                            </a>
                            <IoMdCloseCircle
                              type="button"
                              onClick={handleDeleteAttachment(attachment.id)}
                              className="delete-icon"
                            />
                          </div>
                        ))}
                      </div>
                    ) : null}
                  </div>

                  <div className="pt-3 pb-2 d-flex justify-content-between align-items-center">
                    <div>
                      <div>
                        <Label
                          htmlFor="file"
                          style={{
                            cursor: 'pointer',
                            margin: 0,
                            padding: '10px',
                            display: 'inline-flex'
                          }}
                        >
                          <FaPaperclip size={16} />
                        </Label>
                        <Input
                          id="file"
                          type="file"
                          multiple
                          onChange={handleAddNewFile}
                          hidden
                          accept=".png, .jpeg, .jpg, .pdf, .doc, .docx, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        />
                      </div>
                    </div>

                    <div style={{ marginRight: '0.5rem' }}>
                      <Button
                        color="success"
                        title="Enviar email"
                        disabled={
                          description.length === 0 || isSendingEmail === true
                        }
                      >
                        {isSendingEmail === true ? (
                          <div className="text-center">
                            <ReactLoader
                              type="TailSpin"
                              color={systemConfiguration.primary_color}
                              height={23}
                              width={23}
                            />
                          </div>
                        ) : (
                          'Enviar email'
                        )}
                      </Button>
                      <UncontrolledDropdown group>
                        <DropdownToggle
                          data-toggle="dropdown"
                          caret
                          color="success"
                        >
                          <IoIosOptions size={20} />
                        </DropdownToggle>
                        <DropdownMenu
                          right
                          style={{
                            width: '352px'
                          }}
                        >
                          <DropdownItem
                            onClick={() => {
                              mustSendSignature(localStorage.getItem('login'));
                              setSendSignature(!sendSignature);
                            }}
                            disabled={!hasSignature}
                          >
                            <OptionSendSignatureWrapper>
                              <OptionSendSignatureDescription>
                                <span>Enviar assinatura</span>
                                <p
                                  className="m-0"
                                  style={{
                                    fontSize: '12px'
                                  }}
                                >
                                  Enviar assinatura para o cliente
                                  <br />
                                  {!hasSignature && (
                                    <SpanSignature>
                                      (assinatura não cadastrada)
                                    </SpanSignature>
                                  )}
                                </p>
                              </OptionSendSignatureDescription>
                              <CheckboxSignatureWrapper>
                                <Input
                                  type="checkbox"
                                  name="signature"
                                  id="signature"
                                  className="ml-2"
                                  checked={sendSignature}
                                />
                              </CheckboxSignatureWrapper>
                            </OptionSendSignatureWrapper>
                          </DropdownItem>
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        )}
      </DefaultModal>
    </>
  );
};

export default SendEmailModal;
